import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        reason: '',
        approved: false
      },
      rules: {
        reason: [{
          required: true,
          message: "请输入原因",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formData.reason = '';
                _this.formData.id = id;
                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this2.$api.review(_this2.formData).then(function (res) {
            if (res.code == 200) {
              _this2.$message.success('操作成功');

              _this2.$emit('change');

              _this2.dialogFormVisible = false;
            } else {
              _this2.$message.error(res.msg);
            }
          });
        }
      });
    }
  }
};